import { FC } from "react";
import { useNavigate } from "react-router-dom";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS, PAGE_URLS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { programTemplateSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { ProgramTemplateSearchHeaderWrapper } from "./ProgramTemplateSearchHeader.style";

interface ProgramTemplateSearchHeaderProps {
  pageId: string;
}

export const ProgramTemplateSearchHeader: FC<
  ProgramTemplateSearchHeaderProps
> = ({ pageId }) => {
  const { fetchLabel, pageTitle } = useSiteCore();
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(PAGE_URLS.CREATE_PROGRAM_TEMPLATE, {
      state: { from: PAGE_URLS.PROGRAM_TEMPLATE },
    });
  };
  return (
    <ProgramTemplateSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <PermissionWrapper
          permission={MODULE_PERMISSIONS.PROGRAM_TEMPLATE_CREATE}
        >
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={handleNavigate}
              className="header-right-button"
              id={`${pageId}-new-button`}
              data-testid={`${pageId}-new-button`}
            >
              {fetchLabel(
                programTemplateSiteCoreKeys.headerNewProgramTemplate,
                programTemplateSiteCoreKeys.headerNewProgramTemplateLabel,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </ProgramTemplateSearchHeaderWrapper>
  );
};
